export interface SummaryTooltipRow {
  label: string;
  value: string;
}

interface SummaryTooltipRowsProps {
  title: string;
  rows: SummaryTooltipRow[];
  /** Optional closing note — used to explain what a card's value feeds into. */
  footer?: string;
}

/** The shared tooltip body every summary card and collapsed chip renders. */
export const SummaryTooltipRows = ({ title, rows, footer }: SummaryTooltipRowsProps) => (
  <div className="flex min-w-[200px] flex-col gap-1">
    <p className="text-xs font-semibold">{title}</p>
    {rows.map(row => (
      <div key={row.label} className="flex items-center justify-between gap-3 text-xs">
        <span className="text-muted-foreground">{row.label}</span>
        <span className="font-medium tabular-nums">{row.value}</span>
      </div>
    ))}
    {footer && <p className="pt-1 text-xs text-muted-foreground">{footer}</p>}
  </div>
);
